import { Component, OnChanges, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { MessageService, MenuItem } from 'primeng/api';
import { EventServicesService } from 'src/app/services/event-services.service';
import { JobServicesService } from 'src/app/services/job-services.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { saveAs } from 'file-saver';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { environment } from 'src/environments/environment';
import { InterviewAnalysis } from '../interview-insights/interview-insights.component';
import { FeedbackFormComponent } from 'src/app/forms/feedback-form/feedback-form.component';

@Component({
    selector: 'app-interview-panel',
    templateUrl: './interview-panel.component.html',
    styleUrls: ['./interview-panel.component.css'],
    providers: [MessageService],
    standalone: false
})

export class InterviewPanelComponent implements OnInit, OnChanges {
  @ViewChild('feedbackForm') feedbackFormComponent!: FeedbackFormComponent;
  
  jitsiAPI: any;
  interviewStarted: boolean = false;
  userDetails: any;
  schoolId: any;
  eventDetails: any;
  studentId: any;
  sideMenuItems: any = [];
  selectedCandidate: any = {};
  paramItems: any;
  userToEdit: any;

  loadingSpinner: boolean = false;
  showFilterSidebar: boolean = false;
  showSettingsSidebar: boolean = false;
  showDownloadSidebar: boolean = false;
  feedbackSlider: boolean = false;
  dialogLoading: boolean = false;
  private panelMembersReady: boolean = false;
  private formContentReady: boolean = false;
  feedbackMode: string = 'create'; // 'create', 'view', 'edit'
  panelMembers: any[] = [];
  selectedPanelMemberId: number | null = null;
  isViewOnlyFeedback: boolean = false;
  originalFeedbackMode: string = 'view';
  displaySaveFilterSettings: boolean = false;
  displaySaveColumnSettings: boolean = false;
  displayUserDetails: boolean = false;
  isInEvent!: boolean;
  showBulkUpload: boolean = false;
  usersList: any;
  displayLobbyCandidates: boolean = true;
  displayLiveCandidates: boolean = false;

  columnSearchTerm: string = '';
  filterSearchTerm: string = '';
  downloadSearchTerm: string = '';
  downloadAs: string = 'excel';
  exportName: string = 'userList';
  selectedJobId: string = '';
  selectedEventId: string = '';
  bulkUpload!: MenuItem[];
  items: MenuItem[] = [];
  StatusColour: string = 'green'
  searchEmail: any;
  searchEmailList: string = "";
  formUuid: string = '';
  userCode: string = '';
  codeLang: string = '';
  searchSubject = new Subject<string>();
  selectAllColumns: boolean = false;

  // Number Var
  first: number = 1;
  last: number = 10;
  pageSize: number = 10;
  pageNumber: number = 1;
  totalLength: number = 0;
  numberOfStages: number = 0;

  candidateList: any = [];
  ongoingList: any = [];
  stages: any = [];
  usersCol: Array<any> = [];
  _usersCol: Array<any> = [];
  _selectedColumns: Array<any> = [];
  colsToDownload: Array<any> = [];
  pageLimits: Array<any> = [10, 25, 50, 100];
  checkedColumns: Array<any> = [];
  columnsToSave: Array<any> = [];
  savedColumnSettings: Array<any> = [];
  selectedUser: Array<any> = [];
  candidateStatus: any = {};
  excel: File[] = [];
  selectedMenuID: string = 'ongoing';
  userType: string = "";
  selectedUsersList: any = [];
  editorOptions: any = [];
  numberOfassigne: string = '';
  recordedVideoSidebarView: boolean = false;
  submittedCodeView: boolean = false;
  showInterviewAnalysis: boolean = false;
  videoLink: any = "";
  displayVideo : boolean = false;
  jobIdAnalysis : number|null = null ;
  isLoading: boolean = false;
  isAnalysisLoading: boolean = false;
  mins: any;
  dateFormat: any;
  timeFormat: any;
  candidateDetails: any;
  userPrivileges: Set<string> = new Set();
  activeLocation: string = '';
  subStatus: string = 'Lobby';
  stageFilterOptions: any[] = [];
  selectedStageId: string = '';
  appliedStageId: string = '';
  skeletonData: any[] = Array(10).fill({}).map((_, index) => ({
    interview_uuid: `skeleton-${index}`,
    userId: `skeleton-${index}`,
    name: '',
    email: ''
  }));

  showEditDialog: boolean = false;
  editingCandidate: any = null;
  editFormClicked: boolean = false;
  editInterviewLoading: boolean = false;
  isEditFormDirty: boolean = false;
  
  insightsExportLoading: boolean = false;

  showDeleteConfirmDialog: boolean = false;
  deletingCandidate: any = null;
  deleteInterviewLoading: boolean = false;

  editInterviewForm!: FormGroup;
  interviewerList: Array<{ label: string; value: number; userId: number; email?: string }> = [];
  selectedEditInterviewers: number[] = [];
  interviewerListLoaded: boolean = false;
  interviewJobRoles: any[] = [];
  currentDate: Date = new Date();
  
  timeSlots: any[] = [];
  durationSlots: any[] = [
    { label: '15 minutes', value: '00:15' },
    { label: '30 minutes', value: '00:30' },
    { label: '45 minutes', value: '00:45' },
    { label: '1 hour', value: '01:00' },
    { label: '1 hour 30 minutes', value: '01:30' },
    { label: '2 hours', value: '02:00' },
    { label: '2 hours 30 minutes', value: '02:30' },
    { label: '2 hours 45 minutes', value: '02:45' },
    { label: '3 hours', value: '03:00' },
    { label: '3 hours 30 minutes', value: '03:30' },
    { label: '4 hours', value: '04:00' },
    { label: '4 hours 30 minutes', value: '04:30' },
    { label: '5 hours', value: '05:00' },
  ];

  private fieldMapping: { [key: string]: string } = {
    'userId': 'candidate_uuid',
    'name': 'first_name',
    'email': 'email',
    'mobile_number': 'mobile_number',
    'interview_mode': 'interview_mode',
    'stageName': 'stage_name',
    'status': 'status',
    'interviewDate': 'interview_start_at',
    'interview_location': 'interview_location',
    'startandEnd': 'interview_end_at',
    'recruiterName': 'interviewer_first_name',
    'isFeedbackSubmitted': 'feedback_status',
    'jobRole': 'job_role_name'
  };

  constructor(private globalservice: GlobalServicesService,
    private eventServices: EventServicesService,
    private JobServicesService: JobServicesService,
    private _router: Router,
    private sanitizer: DomSanitizer,
    private globalService: GlobalServicesService,
    private activatedRoute: ActivatedRoute,
    public messageService: MessageService,
    private cdr: ChangeDetectorRef,
    private globalServicesService: GlobalServicesService,
    private sharedServices: SharedServicesService) 
    {


    this.sideMenuItems = [
      { id: 'allCandidates', name: 'All Candidates', isActive: true, view: true },
      { id: 'lobby', name: 'Lobby', isActive: false, view: true },
      { id: 'ongoing', name: 'Ongoing', isActive: (this.userType == 'recruiter') ? true : false, view: true },
      { id: 'completed', name: 'Completed', isActive: false, view: true },
      { id: 'cancelled', name: 'Cancelled', isActive: false, view: true },
    ];
    this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(value => {
      const trimmed = value.trim();
      this.searchEmailList = trimmed;  
      if (trimmed.length >= 3 || trimmed.length === 0) {
        this.openSideMenu(this.selectedMenuID);
      }
    });
  }

  columnSettings: FormGroup = new FormGroup({
    name: new FormControl(''),
    saved_columns: new FormControl(this.columnsToSave)
  })

  ngOnInit(): void {
    this.globalservice.userMeta$.subscribe(meta => {
      if (meta && meta.user_profile) {
        this.userDetails = meta.user_profile;        
        this.userType = meta.role_details?.name || '';
      }
    });
    this.dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.date_format : '';
    this.timeFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.time_format : '';

    this._usersCol = this.usersCol;
    this.colsToDownload = this.usersCol;
    this.checkedColumns = this._selectedColumns;
    this.activatedRoute.params.subscribe(params => {
      this.selectedEventId = params['eventId'] || '';
      if (this.selectedEventId) {
        const request = this.sharedServices.initiateEventDetailsRequest(
          this.selectedEventId,
          () => this.eventServices.getSpecificEventFastApi(this.selectedEventId)
        );
        
        if (request) {
          request.subscribe({
            next: (response) => {
              this.eventDetails = response.body?.event_details;
              this.loadJobRoles();
            },
            error: (error) => {
            }
          });
        }
      }
    });
    this.schoolId = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}').company_settings?.school_code : '';
    const companyDetails = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details') || '{}') : {};
    this.showInterviewAnalysis = companyDetails.company_metadata?.company_config?.interview_analysis ?? false;
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });
    this.items = [{
      label: 'Options',
      items: [
        {
          label: 'Feedback',
          icon: 'pi pi-comment',
          command: () => {
            this.openFeedback(this.userToEdit);
          }
        }
      ]
    },]
    const deepLink = this.activatedRoute.snapshot.queryParamMap;
    const deepLinkStage = deepLink.get('stage') || '';
    const deepLinkSub = deepLink.get('subStatus') || '';
    if (deepLinkStage) {
      this.selectedStageId = deepLinkStage;
      this.appliedStageId = deepLinkStage;
    }
    const interviewTabs = ['lobby', 'ongoing', 'completed', 'cancelled'];
    if (deepLinkSub && interviewTabs.includes(deepLinkSub)) {
      this.openSideMenu(deepLinkSub);
    } else {
      const activeMenu = this.sideMenuItems.find((menu: any) => menu.isActive);
      this.openSideMenu(activeMenu?.id);
    }

    this.initEditInterviewForm();
    this.generateTimeSlots();    
    if (this.userPrivileges.has('event_stage.view') && this.selectedEventId) {
      this.loadStageFilterOptions();
    }
  }
  onFilterSidebarShow(): void {
    this.selectedStageId = this.appliedStageId;
    if (this.userPrivileges.has('event_stage.view') && this.selectedEventId && !this.stages.length) {
      this.loadStageFilterOptions();
    }
  }

  onColumnPreferenceClick(): void {
    this.showSettingsSidebar = true;
    this.showFilterSidebar = false;
    this.showDownloadSidebar = false;
    this.getSavedColumns();
}
  getSavedColumns = () => {
    this.eventServices.getUserPreferencesFastApi('event_interview').subscribe({
      next: (res: any) => {
        this.savedColumnSettings = res?.body?.user_preferences ? res.body.user_preferences : [];
      },
      error: () => {
        this.savedColumnSettings = [];
      }
    });
  }
  saveColumnSettings = () => {
    this.loadingSpinner = true;    
    this.columnsToSave = this.checkedColumns.map(e => {
      return this.fieldMapping[e.field] || e.field;
    });

    this.columnSettings.setValue({
      name: this.columnSettings.get("name")?.value,
      saved_columns: this.columnsToSave
    });

    this.eventServices.saveUserPreferencesFastApi(this.columnSettings.value, 'event_interview').subscribe({
      next: (result: any) => {
        this.getSavedColumns();
        this.loadingSpinner = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: result.body.detail,
        });
        this.clearColumnPreferenceName();
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }

  deleteSavedColumns = (columnId: string) => {
    this.loadingSpinner = true;
    this.eventServices.deleteUserPreferencesFastApi(columnId).subscribe({
      next: res => {
        this.getSavedColumns();
        this.loadingSpinner = false;
      },
      error: () => {
        this.loadingSpinner = false;
      }
    });
  }
  applySavedSettings = (savedColumnValue: Array<any>) => {
    this.checkedColumnsBackup = this._usersCol.filter(e =>
      savedColumnValue.includes(this.fieldMapping[e.field] || e.field)
    );
    this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
  }

  applySelectedColumns = () => {
    this.checkedColumns = this.checkedColumnsBackup;
    this._selectedColumns = this.sortedColumns();
    this.showSettingsSidebar = false;
  }

  clearSelectedColumns = () => {
    this.checkedColumns = [];
  }

  private sortedColumns(): any[] {
    return this.checkedColumns.sort((a, b) => (a.index < b.index) ? -1 : 1);
  }

  searchColumns = (searchTerm: string) => {
    this.columnSearchTerm = searchTerm;
    if (this.showSettingsSidebar) {
      this._usersCol = this.usersCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }

    if (this.showDownloadSidebar) {
      this.colsToDownload = this.usersCol.filter(val => val.header.toLowerCase().includes(searchTerm.toLowerCase()));
    }
  }
  onSearchChange(value: string) {
    this.searchSubject.next(value);
  }
  showLocationPopover(event: Event, location: string, panel: any): void {
    this.activeLocation = location;
    panel.toggle(event);
  }
  private readonly INTERVIEW_STAGE_TYPES = ['Online Interview', 'Offline Interview', 'AI Interview'];

  loadStageFilterOptions = () => {
    this.eventServices.getEventFormDataWithQueryFastApi(this.selectedEventId, 'stage').subscribe({
      next: (res: any) => {
        if (res?.body?.stages && Array.isArray(res.body.stages)) {
          const interviewStages = res.body.stages.filter((stage: any) =>
            this.INTERVIEW_STAGE_TYPES.includes(stage.type)
          );
          this.stages = interviewStages.map((stage: any) => ({
            ...stage,
            form: stage.form || { uuid: stage.form_uuid }
          }));
          this.stageFilterOptions = [
            { label: 'All Stages', value: '' },
            ...interviewStages.map((stage: any) => ({
              label: stage.name,
              value: stage.uuid
            }))
          ];
        }
      },
      error: () => {
        this.stageFilterOptions = [{ label: 'All Stages', value: '' }];
      }
    });
  }

  
  setColumns = (selectedMenuID: string) => {
    if (selectedMenuID === 'lobby') {
      this.usersCol = [
          { index: 3, field: 'email', header: 'E-mail' },
          { index: 4, field: 'stageName', header: 'Stage Name' },
          { index: 5, field: 'jobRole', header: 'Role' },
          { index: 6, field: 'action', header: 'Join' },
          { index: 7, field: 'status', header: 'Status' },
          { index: 8, field: 'mobile_number', header: 'Phone' },
          { index: 9, field: 'interview_mode', header: 'Interview Mode' },
          { index: 10, field: 'providerDisplay', header: 'Interview Provider' },
          { index: 11, field: 'interviewDate', header: 'Interview Date' },
          { index: 12, field: 'startandEnd', header: 'Interview Time' },
          { index: 13, field: 'interview_location', header: 'Interview Location' },
          { index: 14, field: 'recruiterName', header: 'Interviewer Name' },
          { index: 15, field: 'isFeedbackSubmitted', header: 'Feedback' },
          { index: 16, field: 'insights', header: 'Insights' },
          { index: 17, field: 'recording', header: 'Recording' }
      ]

      this._selectedColumns = [
          { index: 3, field: 'email', header: 'E-mail' },
          { index: 4, field: 'stageName', header: 'Stage Name' },
          { index: 5, field: 'jobRole', header: 'Role' },
          { index: 6, field: 'action', header: 'Join' },
          { index: 7, field: 'status', header: 'Status' },
          // { index: 8, field: 'mobile_number', header: 'Phone' },
          { index: 9, field: 'interview_mode', header: 'Interview Mode' },
          // { index: 10, field: 'providerDisplay', header: 'Interview Provider' },
          // { index: 11, field: 'interviewDate', header: 'Interview Date' },
          // { index: 12, field: 'startandEnd', header: 'Interview Time' },
          // { index: 14, field: 'recruiterName', header: 'Interviewer Name' },
          // { index: 15, field: 'isFeedbackSubmitted', header: 'Feedback' }
          { index: 16, field: 'insights', header: 'Insights' },
          { index: 17, field: 'recording', header: 'Recording' }
      ]
      this.checkedColumns = [...this._selectedColumns];
      this._usersCol = [...this.usersCol];
      this.colsToDownload = [...this._usersCol];

  }
   else if (selectedMenuID === 'ongoing') {
      this.usersCol = [
        { index: 3, field: 'email', header: 'E-mail' },
        { index: 4, field: 'stageName', header: 'Stage Name' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'action', header: 'Join' },
        { index: 7, field: 'status', header: 'Status' },
        { index: 8, field: 'mobile_number', header: 'Phone' },
        { index: 9, field: 'interview_mode', header: 'Interview Mode' },
        { index: 10, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 11, field: 'interviewDate', header: 'Interview Date' },
        { index: 12, field: 'startandEnd', header: 'Interview Time' },
        { index: 13, field: 'interview_location', header: 'Interview Location' },
        { index: 14, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 15, field: 'isFeedbackSubmitted', header: 'Feedback' },
        { index: 16, field: 'insights', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' }
      ]

      this._selectedColumns = [
        { index: 3, field: 'email', header: 'E-mail' },
        { index: 4, field: 'stageName', header: 'Stage Name' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'action', header: 'Join' },
        { index: 7, field: 'status', header: 'Status' },
        // { index: 8, field: 'mobile_number', header: 'Phone' },
        { index: 9, field: 'interview_mode', header: 'Interview Mode' },
        // { index: 10, field: 'providerDisplay', header: 'Interview Provider' },
        // { index: 11, field: 'interviewDate', header: 'Interview Date' },
        // { index: 12, field: 'startandEnd', header: 'Interview Time' },
        // { index: 13, field: 'interview_location', header: 'Interview Location' },
        // { index: 14, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 15, field: 'isFeedbackSubmitted', header: 'Feedback' },
        { index: 16, field: 'insights', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' }
      ]
      this.checkedColumns = [...this._selectedColumns];
      this._usersCol = [...this.usersCol];
      this.colsToDownload = [...this._usersCol];

    } else if (selectedMenuID === 'completed') {
      this.usersCol = [
        { index: 3, field: 'email', header: 'E-mail' },
        { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 9, field: 'status', header: 'Status' },
        { index: 10, field: 'interviewDate', header: 'Interview Date' },
        { index: 11, field: 'startandEnd', header: 'Interview Time' },
        { index: 12, field: 'interview_location', header: 'Interview Location' },
        { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 14, field: 'isFeedbackSubmitted', header: 'Feedback' },
        { index: 15, field: 'sourceCode', header: 'Submitted Code' },
        { index: 16, field: 'action', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' },
        { index: 18, field: 'mins', header: 'Duration' }
      ]

      this._selectedColumns = [
        { index: 3, field: 'email', header: 'E-mail' },
        // { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        // { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 9, field: 'status', header: 'Status' },
        // { index: 10, field: 'interviewDate', header: 'Interview Date' },
        // { index: 11, field: 'startandEnd', header: 'Interview Time' },
        // { index: 12, field: 'interview_location', header: 'Interview Location' },
        // { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 14, field: 'isFeedbackSubmitted', header: 'Feedback' },
        // { index: 15, field: 'submittedCode', header: 'Submitted Code' },
        { index: 16, field: 'action', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' },
        // { index: 18, field: 'mins', header: 'Duration' }
      ]
      this.checkedColumns = [...this._selectedColumns];
      this._usersCol = [...this.usersCol];
      this.colsToDownload = [...this._usersCol];

    } else if (selectedMenuID === 'cancelled') {
      this.usersCol = [
        { index: 3, field: 'email', header: 'E-mail' },
        { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 9, field: 'status', header: 'Status' },
        { index: 10, field: 'interviewDate', header: 'Interview Date' },
        { index: 11, field: 'startandEnd', header: 'Interview Time' },
        { index: 12, field: 'interview_location', header: 'Interview Location' },
        { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
      ]

      this._selectedColumns = [
        { index: 3, field: 'email', header: 'E-mail' },
        // { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        // { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 9, field: 'status', header: 'Status' },
        // { index: 10, field: 'interviewDate', header: 'Interview Date' },
        // { index: 11, field: 'startandEnd', header: 'Interview Time' },
        // { index: 12, field: 'interview_location', header: 'Interview Location' },
        { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
      ]
      this.checkedColumns = [...this._selectedColumns];
      this._usersCol = [...this.usersCol];
      this.colsToDownload = [...this._usersCol];

    } else {
      this.usersCol = [
        { index: 3, field: 'email', header: 'E-mail' },
        { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 9, field: 'status', header: 'Status' },
        { index: 10, field: 'interviewDate', header: 'Interview Date' },
        { index: 11, field: 'startandEnd', header: 'Interview Time' },
        { index: 12, field: 'interview_location', header: 'Interview Location' },
        { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 14, field: 'isFeedbackSubmitted', header: 'Feedback' },
        { index: 15, field: 'action', header: 'Join' },
        { index: 16, field: 'insights', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' },
      ]

      this._selectedColumns = [
        { index: 3, field: 'email', header: 'E-mail' },
        // { index: 4, field: 'mobile_number', header: 'Phone' },
        { index: 9, field: 'status', header: 'Status' },
        { index: 8, field: 'stageName', header: 'Stage Name' },
        { index: 5, field: 'jobRole', header: 'Role' },
        { index: 14, field: 'isFeedbackSubmitted', header: 'Feedback' },
        // { index: 13, field: 'recruiterName', header: 'Interviewer Name' },
        { index: 6, field: 'interview_mode', header: 'Interview Mode' },
        // { index: 7, field: 'providerDisplay', header: 'Interview Provider' },
        // { index: 10, field: 'interviewDate', header: 'Interview Date' },
        // { index: 11, field: 'interview_location', header: 'Interview Location' },
        // { index: 12, field: 'startandEnd', header: 'Interview Time' },
        { index: 16, field: 'insights', header: 'Insights' },
        { index: 17, field: 'recording', header: 'Recording' }
      ]
      this.checkedColumns = [...this._selectedColumns];
      this._usersCol = [...this.usersCol];
      this.colsToDownload = [...this._usersCol];
    }

  }

  get getActiveFilterCounts(): number {
    let count = 0;
    if (this.appliedStageId) count++;
    return count;
  }

  onStageFilterChange(selectedStageId: string) {
    this.selectedStageId = selectedStageId;
    this.appliedStageId = selectedStageId;
    this.pageNumber = 1;
    this.first = 1;
    this.selectedUsersList = [];
    this.getDataByLimitPage();
  }

  get selectedStageLabel(): string {
    if (!this.selectedStageId) {
      return 'All Stages';
    }
    const selectedStage = this.stageFilterOptions.find(option => option.value === this.selectedStageId);
    return selectedStage ? selectedStage.label : 'All Stages';
  }
  onCloseFeedbackSlider(success: boolean) {
    this.feedbackSlider = false;
    this.panelMembers = [];
    this.selectedPanelMemberId = null;
    this.isViewOnlyFeedback = false;
  }

  onFeedbackDialogHide() {
    if (this.feedbackFormComponent) {
      this.feedbackFormComponent.resetFormToOriginalState();
    }
    this.feedbackMode = 'create';
    this.panelMembers = [];
    this.selectedPanelMemberId = null;
    this.isViewOnlyFeedback = false;
    this.dialogLoading = false;
    this.panelMembersReady = false;
    this.formContentReady = false;
    this.openSideMenu(this.selectedMenuID);
  }
  
  viewRecordedVideo(user: any) {
    this.selectedCandidate = user;
    const payload: any = {
      candidate_uuid: this.selectedCandidate.candidate_uuid,
      stage_uuid: this.selectedCandidate.stage_uuid,
      event_uuid: this.selectedEventId,
      interview_uuid: this.selectedCandidate.interview_uuid,
      job_role_id: this.selectedCandidate.job_role_id,
      provider: this.selectedCandidate.provider || 'default',
      interview_mode: this.selectedCandidate.interview_mode,
    };
    this.eventServices.interviewInsights$.next({ eventDetails: this.eventDetails, candidateDetails: this.selectedCandidate });
    const url = this._router.serializeUrl(
      this._router.createUrlTree(['/interview-insights'], { queryParams: payload })
    );
    window.open(url, '_blank');
  }

  openRecording(user: any) {
    if (user.interview_recording_url) {
      this.videoLink = this.sanitizer.bypassSecurityTrustResourceUrl(user.interview_recording_url)
    }
    this.recordedVideoSidebarView = true
    this.selectedCandidate = user
    this.displayVideo = true
  }


  tableRefresh() {
    this.getDataByLimitPage();
  }

  openSideMenu(selectedMenuID: string, event?: any) {
    this.selectedMenuID = selectedMenuID
    this.checkedColumns = [];
    this.selectedUsersList = [];
    let data = event?.target?.value;
    if (data?.length) {
      data = data.trim();
      this.searchEmail = data?.trim().split(/\s+/);
    }
    else if (this.searchEmailList?.length) {
      data = this.searchEmailList;
      this.searchEmail = data?.trim().split(/\s+/);
    }
    else {
      this.searchEmail = [];
    }
    this.sideMenuItems.map((menu: any) => {
      if (menu.id === selectedMenuID) {
        if (!menu.isActive) {
          this.searchEmailList = "";
          this.searchEmail = [];
          this.searchSubject.next('');
        }
        this.pageSize = 10;
        menu.isActive = true;
        this.getUsersByLimit();
      } else {
        menu.isActive = false;
      }
    })
  }

  ngOnChanges(): void {
    this.jitsiAPI.addListener('videoConferenceLeft', () => {
      this.interviewStarted = false;
    })
  }

  searchEmailCandidate = (event: any) => {
    let data = event.target.value;
    this.searchEmail = data.trim().split(/\s+/);

  }


  getUsersByLimit = () => {
    this.showFilterSidebar = false;
    this.showSettingsSidebar = false;
    this.showDownloadSidebar = false;
    this.pageNumber = 1;
    this.first = 1;
    this.last = 0;
    this.getDataByLimitPage();
  };

  setlast() {
    if (this.last === 0) {
      this.last = this.pageSize <= this.totalLength ? this.pageSize : this.totalLength;
    }
  }


  next(): void {
    this.first = this.first + this.pageSize;
    this.last = this.last + this.pageSize < this.totalLength ? this.pageSize + this.last : this.totalLength;
    this.pageNumber += 1;
    this.getDataByLimitPage();
  }

  prev(): void {
    this.first = this.first - this.pageSize;
    this.last = this.last - this.pageSize >= this.totalLength ? this.totalLength - this.last : this.pageSize;
    this.pageNumber -= 1;
    this.getDataByLimitPage();
  }

  isLastPage(): boolean {
    return !this.totalPages || this.pageNumber === this.totalPages;
  }

  isFirstPage(): boolean {
    return this.first > 1 ? false : true;
  }
  get totalPages(): number {
    return Math.ceil(this.totalLength / this.pageSize) || 1;
  }  

  handleSelection = (event: any) => {
    this.selectedUsersList = event;
  }

  exportCandidate = (type: string) => {
    let checkedColumnFields: any = ['name'];
    this.checkedColumns.forEach((each) => {
      checkedColumnFields.push(each.field);
    });
    let afterFilter: any = [];
    this.candidateList.forEach((eachData: any) => {
      let filterData: any = {};
      checkedColumnFields.forEach((item: any) => {
        eachData.hasOwnProperty(item) && (filterData[item] = eachData[item]);
      });
      if (
        checkedColumnFields.find((element: string) => element === 'location')
      ) {
        let locationString: string = '';
        eachData.locationInformation.forEach((eachlocation: any) => {
          locationString +=
            `${locationString.length ? ', ' : ''}` + eachlocation.location;
        });
        filterData['location'] = locationString;
      }
      afterFilter.push(filterData);
    });
    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(afterFilter);
      const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, { bookType: type === 'excel' ? 'xlsx' : 'csv', type: 'array' });
      this.saveAsExcelFile(excelBuffer, this.exportName, type);
    });
  }

  saveAsExcelFile(buffer: any, fileName: string, type: string): void {
    let FILE_TYPE =
      type === 'excel'
        ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
        : 'text/csv';
    let FILE_EXTENSION = type === 'excel' ? '.xlsx' : '.csv';
    const data: Blob = new Blob([buffer], {
      type: FILE_TYPE,
    });
    saveAs(data, fileName + '_export_' + new Date().getTime() + FILE_EXTENSION);
    this.showDownloadSidebar = false;
    this.resetCheckedColumnsToDefault();
  }


  openJitsiContainer(data: any) {
    const userID = data.userId;
    const interviewId = data.interview_uuid;
    const eventId = this.selectedEventId;
    if (data.interview_mode === 'Online') {
      const providerMeetingUrl = data.provider_meeting_url;

      if (providerMeetingUrl) {
        window.open(providerMeetingUrl, '_blank');
        setTimeout(() => {
          this.tableRefresh();
        }, 1000);
        return;
      }

      const urlTree = this._router.createUrlTree(['/jitsiContainer'], {
        queryParams: {
          userID,
          eventId,
          interviewId,
          c_userName: this.userDetails.first_name,
          schoolId: this.schoolId,
          stageId: data.stage_uuid,
          feedbackStatus: data.feedback_status
        }
      });

      const baseUrl = window.location.origin;
      const url = baseUrl + this._router.serializeUrl(urlTree);

      window.open(url, '_blank');
      setTimeout(() => {
        this.tableRefresh();
      }, 1000);
    }
  }

  offlineInterviewJoin(data: any) {
    const userStage = this.stages.find((stage: any) => stage.uuid === data.stage_uuid);
    if (userStage) {
      this.formUuid = userStage.form_uuid || userStage.form?.uuid || '';
    }
    const queryParams = {
      interview_uuid: data.interview_uuid?.toString() || '',
      candidate_uuid: data.userId?.toString() || '',
      form_uuid: this.formUuid?.toString() || '',
      event_uuid: this.selectedEventId?.toString() || '',
      stage_uuid: data.stage_uuid?.toString() || '',
      feedback_status: (data?.feedback_status === "Submitted").toString(),
      interview_mode: data.interview_mode?.toString() || ''
    };

    this.updateInterviewStatus("IN_MEETING", data);

    const searchParams = new URLSearchParams(queryParams);
    const feedbackUrl = `${window.location.origin}/feedback-form?${searchParams}`;
    window.open(feedbackUrl, '_blank');
    setTimeout(() => {
      this.tableRefresh();
    }, 1000);
  }

  updateInterviewStatus(status: string, data: any) {
    let payload: any = {"status": status};
    this.eventServices.adminUpdateInterviewStatusFastApi(payload, this.selectedEventId, data.interview_uuid).subscribe({
        next: (response: any) => {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: `Interview started for ${data.first_name} ${data.last_name}` });
        }
    });
};

  openFeedback = (user: any, action?: string) => {
    const userStage = this.stages.find((stage: any) => stage.uuid === user.stage_uuid);
    if (userStage) {
      this.formUuid = userStage.form_uuid || userStage.form?.uuid || '';
    }
    
    if (user.isFeedbackSubmitted) {
      this.feedbackMode = this.userPrivileges.has('event_interview.edit_feedback_form') ? 'edit' : 'view';
    } else {
      this.feedbackMode = 'create';
    }
    this.originalFeedbackMode = this.feedbackMode;
    this.isViewOnlyFeedback = false;

    this.paramItems = {
      eventId: this.selectedEventId,
      stageId: user.stageId,
      userID: user.userId,
      candidateEmail: user.email
    };
    this.candidateDetails = {};
    this.candidateDetails.candidate_name = user.name;
    this.candidateDetails.candidate_uuid = user.userId;
    this.candidateDetails.candidate_email = user.email;
    this.candidateDetails.stage_uuid = user.stage_uuid;
    this.candidateDetails.event_uuid = this.selectedEventId;
    this.candidateDetails.interview_uuid = user.interview_uuid;
    this.candidateDetails.profilePic = user.photo;
    this.panelMembers = [];
    this.selectedPanelMemberId = null;
    this.dialogLoading = true;
    this.panelMembersReady = false;
    this.formContentReady = false;
    this.feedbackSlider = true;
  }

  openPanelMemberView(user: any) {
    const userStage = this.stages.find((stage: any) => stage.uuid === user.stage_uuid);
    if (userStage) {
      this.formUuid = userStage.form_uuid || userStage.form?.uuid || '';
    }

    if (user.isFeedbackSubmitted) {
      this.feedbackMode = 'view';
      this.originalFeedbackMode = this.userPrivileges.has('event_interview.edit_feedback_form') ? 'edit' : 'view';
      this.isViewOnlyFeedback = true;
    } else {
      this.feedbackMode = 'create';
      this.originalFeedbackMode = 'create';
      this.isViewOnlyFeedback = false;
    }

    this.paramItems = {
      eventId: this.selectedEventId,
      stageId: user.stageId,
      userID: user.userId,
      candidateEmail: user.email
    };
    this.candidateDetails = {
      candidate_name: user.name,
      candidate_uuid: user.userId,
      candidate_email: user.email,
      stage_uuid: user.stage_uuid,
      event_uuid: this.selectedEventId,
      interview_uuid: user.interview_uuid,
      profilePic: user.photo
    };
    this.panelMembers = [];
    this.selectedPanelMemberId = null;
    this.dialogLoading = true;
    this.panelMembersReady = false;
    this.formContentReady = false;
    this.feedbackSlider = true;
  }

  selectPanelMember(member: any) {
    if (this.selectedPanelMemberId === member.submitted_by_id) return;
    this.selectedPanelMemberId = member.submitted_by_id;
    const isCurrentUser = member.submitted_by_id === this.userDetails?.id;

    if (member.isVirtual) {
      this.feedbackMode = 'create';
      this.isViewOnlyFeedback = false;
      this.feedbackFormComponent?.resetToCreateMode();
    } else {
      this.isViewOnlyFeedback = !isCurrentUser;
      this.feedbackMode = isCurrentUser ? this.originalFeedbackMode : 'view';
      this.feedbackFormComponent?.loadPanelMemberFeedback(member.form_id);
    }
  }

  onPanelMembersLoaded(members: any[]) {
    if (this.panelMembers.length > 0) return;
    const currentUserId = this.userDetails?.id;
    this.panelMembers = members.sort((a: any, b: any) => {
      if (a.submitted_by_id === currentUserId) return -1;
      if (b.submitted_by_id === currentUserId) return 1;
      return 0;
    });
    const currentUserMember = this.panelMembers.find(
      (m: any) => m.submitted_by_id === currentUserId
    );
    if (currentUserMember) {
      this.selectedPanelMemberId = currentUserMember.submitted_by_id;
      this.feedbackMode = this.originalFeedbackMode;
      this.isViewOnlyFeedback = false;
      if (currentUserMember.form_id) {
        this.feedbackFormComponent?.loadPanelMemberFeedback(currentUserMember.form_id);
      }
    } else if (this.panelMembers.length > 0) {
      const currentUserEntry = {
        submitted_by_id: currentUserId,
        submitted_by_name: this.userDetails?.name || 'You',
        submitted_date: null,
        isVirtual: true
      };
      this.panelMembers = [currentUserEntry, ...this.panelMembers];
      this.selectedPanelMemberId = currentUserId;
      this.feedbackMode = 'create';
      this.isViewOnlyFeedback = false;
      this.feedbackFormComponent?.resetToCreateMode();
    }
    this.panelMembersReady = true;
    this.checkDialogReady();
  }

  onFeedbackLoadingChange(loading: boolean) {
    this.formContentReady = !loading;
    this.checkDialogReady();
  }

  private checkDialogReady() {
    if (this.panelMembersReady && this.formContentReady) {
      this.dialogLoading = false;
    }
  }

  isAIInterviewStage(user: any): boolean {
    if (!user) return false;    
    if (user.interview_mode === 'AI') {
      return true;
    }    
    if (user.stage_uuid && this.stages.length) {
      const userStage = this.stages.find((stage: any) => stage.uuid === user.stage_uuid);
      return userStage?.type === 'AI Interview';
    }
    
    return false;
  }

  hasAIInterviewInSelection(): boolean {
    if (!this.selectedUsersList || this.selectedUsersList.length === 0) {
      return false;
    }
    return this.selectedUsersList.some((user: any) => this.isAIInterviewStage(user));
  }


  downloadAllInsights() {
    if (this.insightsExportLoading) return;

    const selected = this.selectedUsersList || [];
    let stageId: string;
    let candidateUuids: string[] | null = null;

    if (selected.length > 0) {
      const stageIds = Array.from(new Set(selected.map((user: any) => user.stage_uuid).filter(Boolean)));
      if (stageIds.length === 0) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Could not determine the interview stage for the selected candidates.'
        });
        return;
      }
      if (stageIds.length > 1) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: 'Selected candidates span multiple stages. Select candidates from a single stage.'
        });
        return;
      }
      stageId = stageIds[0] as string;
      candidateUuids = selected.map((user: any) => user.candidate_uuid).filter(Boolean);
    } else if (this.appliedStageId) {
      stageId = this.appliedStageId;
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Select a stage',
        detail: 'Choose an interview stage from the filter, or select candidates, to download insights.'
      });
      return;
    }

    this.insightsExportLoading = true;
    const payload: any = { stage_uuid: stageId };
    if (candidateUuids?.length) {
      payload.candidate_uuids = candidateUuids;
    }

    this.JobServicesService.exportInterviewInsightsFastApi(this.selectedEventId, payload).subscribe({
      next: (response: any) => {
        this.insightsExportLoading = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Process Started',
          detail: response?.body?.message || 'Your download request is submitted. The file will be sent to your email shortly.'
        });
      },
      error: () => {
        this.insightsExportLoading = false;
      }
    });
  }

  openViewCode = (user: any) => {
    this.userCode = user.submittedCode;
    this.codeLang = user.submittedLanguage;
    this.editorOptions = { theme: 'vs-dark', language: user.submittedLanguage };
    this.submittedCodeView = true;
  }
  showCandidateDetails(user: any, column: any) {
    const allowedFields = ["email", "mobile_number", "name", "stageName", "status", "userId"];
    if (column?.field && allowedFields.includes(column.field)) {
      user.id = user.userId;
      this.selectedUser = user;
      this.displayUserDetails = true;
    }
  }

  getDataByLimitPage() {
    switch (this.selectedMenuID) {
        case "allCandidates": {
            this.setColumns(this.selectedMenuID)
            this.getCandidatesByStatus("all");
            break;
        }
        case "lobby": {
            this.setColumns(this.selectedMenuID)
            this.getCandidatesByStatus("lobby");
            break;
        }
        case "ongoing": {
            this.setColumns(this.selectedMenuID)
            this.getCandidatesByStatus("ongoing");
            break;
        }
        case "completed": {
            this.setColumns(this.selectedMenuID)
            this.getCandidatesByStatus(this.selectedMenuID);
            break;
        }
        case "cancelled": {
            this.setColumns(this.selectedMenuID)
            this.getCandidatesByStatus("cancelled");
            break;
        }
    }
}

  getCandidatesByStatus(interviewStatus: string) {
    this.candidateList = [];
    this.totalLength = 0;
    this.loadingSpinner = true;
    const searchString = Array.isArray(this.searchEmail) ? this.searchEmail.join(' ') : this.searchEmail || '';
    this.JobServicesService.getInterviewCandidatesByStatusFastApi( this.selectedEventId, interviewStatus, this.pageNumber, this.pageSize, searchString,'desc',this.selectedStageId).subscribe(
    (response: any) => {
      const tempData = response.body.items.map((data: any) => {
        return {
          ...data,
          userId: data.candidate_uuid,
          candidate_uuid: data.candidate_uuid,
          interview_uuid: data.interview_uuid,
          name: `${data.first_name} ${data.last_name}`.trim(),
          stageName: data.stage_name || '-',
          jobRoleId: data.job_role_id || '-',
          jobRole: data.job_role_name || '-',
          interviewDate: data.interview_start_at ? 
            moment(data.interview_start_at).format(this.dateFormat.toUpperCase()) : 
            '-',
          startandEnd: data.interview_start_at && data.interview_end_at ? 
            `${moment(data.interview_start_at).format(this.timeFormat === 'hh:mm' ? 'hh:mm A' : 'HH:mm')} - ${moment(data.interview_end_at).format(this.timeFormat === 'hh:mm' ? 'hh:mm A' : 'HH:mm')}` : 
            '-',
          recruiterName: data.interviewer_first_name && data.interviewer_last_name ? 
            `${data.interviewer_first_name} ${data.interviewer_last_name}`.trim() : 
            '-',
          interviewers: data.interviewers && Array.isArray(data.interviewers) ? data.interviewers.map((iv: any) => ({
            id: iv.id,
            name: iv.name || `${iv.first_name || ''} ${iv.last_name || ''}`.trim()
          })).filter((iv: any) => iv.name) : [],
          interviewerNames: data.interviewers && Array.isArray(data.interviewers) ? data.interviewers.map((iv: any) => iv.name || `${iv.first_name || ''} ${iv.last_name || ''}`.trim()).filter((name: string) => name) : [],
          status: data.status || '-',
          mobile_number: data.mobile_number || '-',
          email: data.email || '-',
          stage_name: data.stage_name || '-',
          mins: data.interview_duration? `${data.interview_duration} min` : '-',
          isFeedbackSubmitted: data.feedback_status === 'Submitted' ? true : false,
          interview_mode: data.interview_mode || '-', 
          interview_location: data.interview_location || '-',
          provider: data.provider || '',
          providerDisplay: data.interview_mode === 'Offline' ? 'Offline' : (data.provider ? (data.provider + '').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase()) : '-'),
          insight_status : '-',
          interview_insight : null
        };
        
      });

      this.candidateList = tempData;
      this.totalLength = response.body.total;
      this.setlast();
      this.loadingSpinner = false;
    });
  }

  capitalize(col: any) {
    let capitalizefield = ["name"];
    if (capitalizefield.includes(col.field)) {
      return true
    }
    return false
  }

  getInterviewerTooltip(interviewers: any[]): string {
    if (!interviewers || interviewers.length <= 1) return '';
    
    const remainingInterviewers = interviewers.slice(1);
    const tooltipContent = remainingInterviewers.map((interviewer, index) => 
      `<div class="tooltip-item">${interviewer || '-'}</div>`
    ).join('');
    
    return `<div class="tooltip-content">${tooltipContent}</div>`;
  }
  getInitials(fullName: string): string {
    if (!fullName) return 'UN';
    
    const names = fullName.trim().split(' ');
    if (names.length === 1) {
      return names[0].charAt(0).toUpperCase();
    }
    
    const firstInitial = names[0].charAt(0).toUpperCase();
    const lastInitial = names[names.length - 1].charAt(0).toUpperCase();
    return firstInitial + lastInitial;
  }
  
  getAvatarColor(name: string): string {
    const colors = [
      '#FF6B35', // Orange-red
      '#4ECDC4', // Teal
      '#45B7D1', // Sky blue
      '#96CEB4', // Mint green
      '#FECA57', // Yellow
      '#FF9FF3', // Pink
      '#54A0FF', // Blue
      '#5F27CD', // Purple
      '#00D2D3', // Cyan
      '#FF9F43', // Orange
      '#EE5A24', // Red-orange
      '#009432', // Green
      '#0652DD', // Dark blue
      '#9980FA', // Light purple
      '#833471', // Dark purple
      '#F79F1F', // Amber
      '#A3CB38', // Lime
      '#1289A7', // Dark teal
      '#D63031', // Red
      '#74B9FF'  // Light blue
    ];
    
    if (!name) return colors[0];    
    let hash = 0;
    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }
    
    return colors[Math.abs(hash) % colors.length];
  }
copyToClipboard(text: string, label: string): void {
  if (!text) return;
  
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text.toString()).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    }).catch((err) => {
      console.error('Clipboard API failed:', err);
      this.fallbackCopyToClipboard(text.toString(), label);
    });
  } else {
    this.fallbackCopyToClipboard(text.toString(), label);
  }
}
getTruncatedId(id: string): string {
  return id ? id.substring(0, 13) + '...' : '';
}
hasValidPhoto(candidate: any): boolean {
  return candidate?.photo && candidate.photo.trim() !== '';
}

onImageError(event: any, candidate: any): void {
  event.target.style.display = 'none';
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'flex';
  }
}

onImageLoad(event: any): void {
  const initialsElement = event.target.nextElementSibling;
  if (initialsElement) {
    initialsElement.style.display = 'none';
  }
}
private fallbackCopyToClipboard(text: string, label: string): void {
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  textArea.style.top = '-999999px';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();
  
  try {
    const successful = document.execCommand('copy');
    if (successful) {
      this.messageService.add({
        severity: 'success',
        summary: 'Copied!',
        detail: `${label} copied to clipboard`,
        life: 2000
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Copy Failed',
        detail: 'Please copy manually: ' + text,
        life: 3000
      });
    }
  } catch (err) {
    console.error('Fallback copy failed:', err);
    this.messageService.add({
      severity: 'error',
      summary: 'Copy Failed',
      detail: 'Please copy manually: ' + text,
      life: 3000
    });
  } finally {
    document.body.removeChild(textArea);
  }
}

isInterviewActionDisabled(candidate: any): boolean {
  if (!candidate) return true;
  const status = (candidate.status || '').toLowerCase();
  return status === 'completed' || status === 'cancelled';
}

toggleSelectAll(): void {
  if (this.selectAllColumns) {
    this.checkedColumns = [...this.colsToDownload];
  } else {
    this.checkedColumns = [...this._selectedColumns];
  }
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
applyFilters() {
  this.showFilterSidebar = false;
  this.selectedUsersList = [];
  this.getDataByLimitPage();
}
clearFilters() {
  this.selectedStageId = '';
  this.filterSearchTerm = '';
  this.showFilterSidebar = false;
  this.selectedUsersList = [];
  this.onStageFilterChange(this.selectedStageId);
}
onColumnCheckChange(): void {
  this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
}
  clearColumnPreferenceName(): void {
    this.columnSettings.get('name')?.setValue('');
    this.displaySaveColumnSettings = false;
  }

  resetCheckedColumnsToDefault(): void {
    this.checkedColumns = [...this._selectedColumns];
    this.selectAllColumns = this.checkedColumns.length === this.colsToDownload.length;
  }

  get selectedJobName(): string | null {
  const selected = this.eventDetails.job_roles.find((job: any) => job.id === this.jobIdAnalysis);
  return selected ? selected.name : null;
  }


    showSaveColumnSettings() {
      this.columnsToSave = this.checkedColumnsBackup.map(e => e.field);
      this.displaySaveColumnSettings = true
    }

    checkedColumnsFields: string[] = [];
    checkedColumnsBackup: any[] = [];
    updatedSelectedColFields() {
      this.checkedColumnsBackup = JSON.parse(JSON.stringify(this.checkedColumns));
      this.checkedColumnsFields = this.checkedColumnsBackup.map((col) => col.field);
    }

    updateCheckedColumns(event: any) {
      this.checkedColumnsFields = event;
      this.checkedColumnsBackup = this._usersCol.filter((col) => event.includes(col.field))
    }

    initEditInterviewForm() {
      this.editInterviewForm = new FormGroup({
        interviewDate: new FormControl(null, Validators.required),
        startTime: new FormControl(null, Validators.required),
        duration: new FormControl(null, Validators.required),
        jobRoleId: new FormControl(null, Validators.required),
        venue: new FormControl(null)
      });
    }

    generateTimeSlots() {
      this.timeSlots = [];
      for (let hour = 0; hour < 24; hour++) {
        for (let minute = 0; minute < 60; minute += 5) {
          const hourStr = hour.toString().padStart(2, '0');
          const minuteStr = minute.toString().padStart(2, '0');
          const value = `${hourStr}:${minuteStr}`;
          
          let displayHour = hour % 12;
          if (displayHour === 0) displayHour = 12;
          const ampm = hour < 12 ? 'AM' : 'PM';
          const formattedTime = `${displayHour.toString().padStart(2, '0')}:${minuteStr} ${ampm}`;
          
          this.timeSlots.push({
            value: value,
            formattedTime: formattedTime,
            hour: hourStr,
            minute: minuteStr
          });
        }
      }
    }

    loadJobRoles() {
      if (this.eventDetails?.job_roles) {
        this.interviewJobRoles = this.eventDetails.job_roles.map((role: any) => ({
          label: role.name,
          value: role.id
        }));
      }
    }

    openEditDialog(candidate: any) {
      this.editingCandidate = candidate;
      this.editFormClicked = false;
      this.loadInterviewerList(candidate);
      // First reset the form
      this.editInterviewForm.reset();
      this.selectedEditInterviewers = [];
      // Then populate with candidate data
      this.populateEditForm(candidate);
      this.showEditDialog = true;
    }

    populateEditForm(candidate: any) {
      let interviewDate: Date | null = null;
      if (candidate.interview_start_at) {
        const utcDate = new Date(candidate.interview_start_at);
        interviewDate = new Date(utcDate.getFullYear(), utcDate.getMonth(), utcDate.getDate());
      }
      
      let startTimeSlot = null;
      if (candidate.interview_start_at) {
        const startDate = new Date(candidate.interview_start_at);
        const hours = startDate.getHours().toString().padStart(2, '0');
        // Round to nearest 5 minutes
        const actualMinutes = startDate.getMinutes();
        const roundedMinutes = Math.round(actualMinutes / 5) * 5;
        const adjustedMinutes = roundedMinutes === 60 ? 0 : roundedMinutes;
        const adjustedHours = roundedMinutes === 60 ? ((startDate.getHours() + 1) % 24).toString().padStart(2, '0') : hours;
        const timeValue = `${adjustedHours}:${adjustedMinutes.toString().padStart(2, '0')}`;
        startTimeSlot = this.timeSlots.find(slot => slot.value === timeValue);
      }

      let durationSlot = null;
      if (candidate.interview_start_at && candidate.interview_end_at) {
        const startMoment = moment(candidate.interview_start_at);
        const endMoment = moment(candidate.interview_end_at);
        const diffMinutes = endMoment.diff(startMoment, 'minutes');
        const hours = Math.floor(diffMinutes / 60);
        const minutes = diffMinutes % 60;
        const durationValue = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
        durationSlot = this.durationSlots.find(d => d.value === durationValue);
        
        if (!durationSlot) {
          if (diffMinutes <= 15) durationSlot = this.durationSlots[0]; // 15 min
          else if (diffMinutes <= 30) durationSlot = this.durationSlots[1]; // 30 min
          else if (diffMinutes <= 45) durationSlot = this.durationSlots[2]; // 45 min
          else if (diffMinutes <= 60) durationSlot = this.durationSlots[3]; // 1 hour
          else if (diffMinutes <= 90) durationSlot = this.durationSlots[4]; // 1.5 hours
          else if (diffMinutes <= 120) durationSlot = this.durationSlots[5]; // 2 hours
          else if (diffMinutes <= 150) durationSlot = this.durationSlots[6]; // 2.5 hours
          else if (diffMinutes <= 165) durationSlot = this.durationSlots[7]; // 2.75 hours
          else if (diffMinutes <= 180) durationSlot = this.durationSlots[8]; // 3 hours
          else if (diffMinutes <= 210) durationSlot = this.durationSlots[9]; // 3.5 hours
          else if (diffMinutes <= 240) durationSlot = this.durationSlots[10]; // 4 hours
          else if (diffMinutes <= 270) durationSlot = this.durationSlots[11]; // 4.5 hours
          else if (diffMinutes <= 300) durationSlot = this.durationSlots[12]; // 5 hours
          else durationSlot = this.durationSlots[12];
        }
      }

      const jobRoleId = typeof candidate.job_role_id === 'string' ? parseInt(candidate.job_role_id) : candidate.job_role_id;
      const jobRoleSlot = this.interviewJobRoles.find(r => r.value === jobRoleId);

      const venueValue = candidate.interview_location && candidate.interview_location !== '-' ? candidate.interview_location : null;
      
      setTimeout(() => {
        this.editInterviewForm.patchValue({
          interviewDate: interviewDate,
          startTime: startTimeSlot,
          duration: durationSlot,
          jobRoleId: jobRoleSlot,
          venue: venueValue
        });
        this.isEditFormDirty = false;
      });

      if (candidate.interviewers && Array.isArray(candidate.interviewers)) {
        this.selectedEditInterviewers = candidate.interviewers
          .filter((iv: any) => iv.id)
          .map((iv: any) => iv.id);
      } else {
        this.selectedEditInterviewers = [];
      }
    }
    
    onEditFormChange(): void {
      this.isEditFormDirty = true;
    }

    loadInterviewerList(candidate?: any) {
      const mergeCandidateInterviewers = (list: typeof this.interviewerList) => {
        if (!candidate?.interviewers?.length) return;
        candidate.interviewers.forEach((iv: any) => {
          if (iv?.id && iv?.name && !list.some(i => i.value === iv.id)) {
            list.push({ label: iv.name, value: iv.id, userId: iv.id, email: '' });
          }
        });
      };

      if (this.interviewerListLoaded && this.interviewerList.length > 0) {
        mergeCandidateInterviewers(this.interviewerList);
        return;
      }

      this.eventServices.getRecruiterListByEventFastApi(this.selectedEventId).subscribe({
        next: (response) => {
          this.interviewerList = [];
          const interviewers = response.body?.interviewers || [];
          
          if (Array.isArray(interviewers) && interviewers.length > 0) {
            interviewers.forEach((user: any) => {
              if (user && user.id && user.first_name && user.last_name) {
                this.interviewerList.push({ 
                  label: `${user.first_name} ${user.last_name}`, 
                  value: user.id, 
                  userId: user.id,
                  email: user.email || ''
                });
              }
            });
          }
          mergeCandidateInterviewers(this.interviewerList);
          this.interviewerListLoaded = true;
        },
        error: (error) => {
          this.interviewerList = [];
          this.interviewerListLoaded = false;
        }
      });
    }

    closeEditDialog() {
      this.showEditDialog = false;
      this.editingCandidate = null;
      this.editFormClicked = false;
      this.selectedEditInterviewers = [];
      this.editInterviewForm.reset();
      this.isEditFormDirty = false;
    }

    updateInterview() {
      this.editFormClicked = true;
      
      if (this.editInterviewForm.invalid) {
        return;
      }

    const formValue = this.editInterviewForm.value;

    const formattedDate = moment(formValue.interviewDate).format('YYYY-MM-DD');

    const startTimeSlot = formValue.startTime;
    let startTimeFormatted = '';
    if (startTimeSlot?.value) {
      const [hours, minutes] = startTimeSlot.value.split(':');
      const hour = parseInt(hours, 10);
      const ampm = hour >= 12 ? 'PM' : 'AM';
      const displayHour = hour % 12 || 12;
      startTimeFormatted = `${displayHour.toString().padStart(2, '0')}:${minutes} ${ampm}`;
    }

    const duration = formValue.duration?.value;

    const payload: any = {
      start_date: formattedDate,
      start_time: startTimeFormatted,
      duration: duration,
      job_role_id: formValue.jobRoleId?.value,
      interviewers: this.selectedEditInterviewers
    };

      if (this.editingCandidate?.interview_mode === 'Offline' && formValue.venue) {
        payload.interview_location = formValue.venue;
      }

      this.editInterviewLoading = true;

      this.eventServices.updateInterviewFastApi(
        this.selectedEventId, 
        this.editingCandidate.stage_uuid, 
        this.editingCandidate.interview_uuid, 
        payload
      ).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Interview updated successfully'
          });
          this.editInterviewLoading = false;
          this.closeEditDialog();
          this.selectedUsersList = [];
          this.tableRefresh();
        },
        error: (error) => {
          this.editInterviewLoading = false;
        }
      });
    }

    openDeleteConfirmDialog(candidate: any) {
      this.deletingCandidate = candidate;
      this.showDeleteConfirmDialog = true;
    }

    closeDeleteConfirmDialog() {
      this.showDeleteConfirmDialog = false;
      this.deletingCandidate = null;
    }

    confirmDeleteInterview() {
      if (!this.deletingCandidate) return;

      this.deleteInterviewLoading = true;

      this.eventServices.deleteInterviewFastApi(
        this.selectedEventId,
        this.deletingCandidate.stage_uuid,
        this.deletingCandidate.interview_uuid
      ).subscribe({
        next: (response) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Interview cancelled successfully'
          });
          this.deleteInterviewLoading = false;
          this.closeDeleteConfirmDialog();
          this.selectedUsersList = [];
          this.tableRefresh();
        },
        error: (error) => {
          this.deleteInterviewLoading = false;
        }
      });
    }

    getInterviewerName(interviewerId: number): string {
      if (this.editingCandidate?.interviewers && Array.isArray(this.editingCandidate.interviewers)) {
        const fromCandidate = this.editingCandidate.interviewers.find((iv: any) => iv.id === interviewerId);
        if (fromCandidate?.name) return fromCandidate.name;
      }
      const interviewer = this.interviewerList.find(i => i.value === interviewerId);
      return interviewer?.label || '';
    }

    getInterviewerInitials(interviewerId: number): string {
      const name = this.getInterviewerName(interviewerId);
      if (!name) return '';
      const parts = name.split(' ');
      if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
      return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
    }

    getInterviewerAvatarColorForEdit(interviewerId: number): string {
      const colors = [
        '#7c3aed', '#2563eb', '#059669', '#d97706', '#dc2626',
        '#8b5cf6', '#0891b2', '#65a30d', '#ea580c', '#be185d'
      ];
      return colors[interviewerId % colors.length];
    }

    removeEditInterviewer(interviewerId: number) {
      this.selectedEditInterviewers = this.selectedEditInterviewers.filter(id => id !== interviewerId);
    }

    onInterviewerPanelShow() {
      this.loadInterviewerList();
    }
  }
